export default __webpack_public_path__ + "static/media/logoE4CE.83bd4a15.png";